module.exports = __webpack_public_path__ + "media/npc_dota_hero_furion.8245e3f4.webm";